export default "__VITE_ASSET__DGtgzjiw__"